// extracted by mini-css-extract-plugin
export default {"SuccessModal":"SuccessModal_SuccessModal__PfZUV","title":"SuccessModal_title__N3Xxv","btnred":"SuccessModal_btnred__4xXvH","galka":"SuccessModal_galka__AIo3L"};